// Home hero animation
gsap.registerPlugin(ScrollTrigger);

function adjustMainMarginForHero() {
  const main = document.querySelector('#MainContent');
  const header = document.querySelector('.nm-header');
  const darkHero = document.getElementById('dark-hero');

  if (!main || !header) return;

  const firstElement = main.firstElementChild;

  if (firstElement && !(firstElement.classList.contains('hero') || firstElement.classList.contains('secondary-hero'))) {
    const headerHeight = header.offsetHeight;

    if (darkHero) {
      main.style.marginTop = '';
    } else {
      main.style.marginTop = `${headerHeight}px`;
    }
  } else {
    main.style.marginTop = '';
  }
}

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    adjustMainMarginForHero();
    window.addEventListener('resize', adjustMainMarginForHero);

    const heroSection = document.querySelector(".shopify-section.hero");
    const mainContent = document.querySelector("main.content-for-layout");
    const introSection = document.querySelector(".shopify-section.intro");
    const heroImage    = document.getElementById('hero-img');
    const heroContent  = document.querySelector('.shopify-section.hero .hero__content');

    if (!heroSection) return;

    window.scrollTo(0, 0);

    const isIntroNext = heroSection?.nextElementSibling === introSection;

    if (mainContent) {
      mainContent.style.paddingTop = "100vh";
    }

    if (isIntroNext && introSection) {
      const overlay = document.createElement("div");
      overlay.className = 'hero-overlay';
      overlay.style.transform = "translateY(0)";
      introSection.appendChild(overlay);
      introSection.classList.add('after-main-hero');
      introSection.style.paddingTop = "120px";
    }

    function updateHeroImageHeight() {
      const heroImage = document.getElementById('hero-img');
      const heroContent = document.querySelector('.shopify-section.hero .hero__content');

      if (!heroImage || !heroContent) return;

      const totalContentHeight = heroContent.offsetHeight;
      const windowHeight = window.innerHeight;
      const newHeight = Math.max(windowHeight - totalContentHeight, 0);

      heroImage.style.height = `${newHeight}px`;
    }

    window.addEventListener('DOMContentLoaded', updateHeroImageHeight);
    window.addEventListener('resize', updateHeroImageHeight);
  });
}());

(function () {
  let activeTriggers = document.querySelectorAll('.js-activeTrigger');

  activeTriggers.forEach(trigger => {
    if (trigger.dataset.bound === 'true') return;

    trigger.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      let dataBody    = trigger.dataset.body_class;
      let focusTarget = trigger.dataset.focus_target;
      let anchor      = trigger.querySelector('a');

      if (anchor) {
        anchor.addEventListener('click', event => {
          event.stopPropagation();
        });
      }

      trigger.classList.remove('js-activeTrigger');

      trigger.classList.toggle('-active');

      if (dataBody) {
        document.body.classList.toggle(dataBody);
      }

      if (focusTarget && trigger.classList.contains('-active')) {
        setTimeout(() => {
          document.querySelector(focusTarget).focus();
        }, 300);
      }
    });

    trigger.dataset.bound = 'true';
  });
}());